import { NuiPlatform } from '../../../common/initialization';

export const clearLastCmdError = (platform: NuiPlatform) => db =>
    platform === 'portal' ? db.setIn(['betslip', 'server', 'lastCmdError'], null) : db.setIn(['serverError'], null);
